import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Driver = ({ user }) => {
  const { t } = useTranslation('translation');
  return (
    <Box
      sx={{
        opacity: user.is_available ? 1 : 0.5,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {user.name} &nbsp;
      <Typography
        fontSize="10px"
        color="text.secondary"
        variant="overline"
        noWrap
      >
        {user.user_formatted_address || user.email}
      </Typography>
      {!user.is_available && (
        <Typography ml={2} component="span">
          ({t('common.unavailable')})
        </Typography>
      )}
    </Box>
  );
};

export default Driver;
